var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('Header'),_c('Platform'),_c('Examples'),_c('Associate'),_c('Create'),_c('Execute'),_c('Mood'),_c('Company'),_c('Team'),_c('Setting'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }